export default __webpack_public_path__ + "static/media/answers_multi.f18b5d22.svg";